import React from 'react';
import { PlusCircle } from '@olxbr/ds-icons';
export const Desapegar = _ref => {
  let {
    active
  } = _ref;
  return React.createElement("span", {
    "aria-hidden": "true",
    className: "navbar-desapegar-wrapper ".concat(active ? 'active' : ''),
    "data-testid": "icon-desapegar"
  }, React.createElement(PlusCircle, null));
};